import { ReactComponent as IconAluno } from "./icon-aluno.svg";
import { ReactComponent as IconBeneficiarioCarteiras } from "./icon-beneficiario-carteiras.svg";
import { ReactComponent as IconBeneficiarioProgramasSociais } from "./icon-beneficiario-programas-sociais.svg";
import { ReactComponent as IconCidadao } from "./icon-cidadao.svg";
import { ReactComponent as IconCondutor } from "./icon-condutor.svg";
import { ReactComponent as IconEmpreendedor } from "./icon-empreendedor.svg";
import { ReactComponent as IconMulher } from "./icon-mulher.svg";
import { ReactComponent as IconPessoaIdosa } from "./icon-pessoa-idosa.svg";
import { ReactComponent as IconProdutorRural } from "./icon-produtor-rural.svg";
import { ReactComponent as IconProprietarioImovel } from "./icon-proprietario-imovel.svg";
import { ReactComponent as IconSaudePublica } from "./icon-saude-publica.svg";
import { ReactComponent as IconServidorPublico } from "./icon-servidor-publico.svg";
import { ReactComponent as IconTurista } from "./icon-turista.svg";

export const iconesPerfis = {
  "icon-condutor": IconCondutor,
  "icon-empreendedor": IconEmpreendedor,
  "icon-produtor-rural": IconProdutorRural,
  "icon-aluno": IconAluno,
  "icon-saude-publica": IconSaudePublica,
  "icon-proprietario-imovel": IconProprietarioImovel,
  "icon-turista": IconTurista,
  "icon-beneficiario-programas-sociais": IconBeneficiarioProgramasSociais,
  "icon-beneficiario-carteiras": IconBeneficiarioCarteiras,
  "icon-cidadao": IconCidadao,
  "icon-servidor-publico": IconServidorPublico,
  "icon-pessoa-idosa": IconPessoaIdosa,
  "icon-mulher": IconMulher,
};

export type IconPerfil = keyof typeof iconesPerfis;

export const getIconComponent = (icon: IconPerfil) => iconesPerfis[icon];
